<template>
	<div class="MainBox" @click.stop="SelectActive(-1,$self)">

    <!-- 面包屑导航 -->
    <K-Column :column="column"></K-Column>

    <!-- 普通行业 -->
    <div class="box FloatBox" v-if="tradeType != 1">
      <div class="FormStyleTwoLeft FloatBoxRow" v-if="uid != 1001">
        <ul class="FormStyleTwo">
          <viewer @inited="inited" ref="viewer">
          <li class="FormStyleTwoImgBox FormStyleTwoRow">
            <div class='FormStyleTwoImg backImg' v-if="FormDatas.img" :style="{backgroundImage: 'url(' + FormDatas.img + ')'}">
              <img v-if="FormDatas.img" class="tableImgShow" :src="FormDatas.img" @click="PreviewImgs">
              <span class="icon iconfont iconicon-test33 RemoveImgIcon" @click.stop="RemoveImg"></span>
            </div>
            <div class='FormStyleTwoImg backImg' v-else></div>
            <div class="FormStyleTwoImgMore">
              <p class="hint" style="width:230px">{{$t('c.Common.ImageSize')}}</p>
              <p class="btnStyleTwo btnRadius blueBackColor" style="display:table;" @click="HandleModel(1,true)">{{$t('b.Material.UploadImages')}}</p>
            </div>
          </li>
          </viewer>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>{{$t('c.Common.ProductName')}}</p>
            <p><input :placeholder="$t('b.ProductManage.HintOne')" v-model="FormDatas.name" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">{{$t('c.Common.VideoLink')}}</p>
            <p><input :placeholder="$t('b.ProductManage.HintOne')" v-model="FormDatas.video" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">{{$t('b.ProductManage.ShelfLife')}}</p>
            <p><input :placeholder="$t('b.ProductManage.HintTwo')" v-model="FormDatas.period" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">{{$t('b.ProductManage.Specification')}}</p>
            <p><input :placeholder="$t('b.ProductManage.HintThree')" v-model="FormDatas.unit" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">{{$t('c.Common.Describe')}}</p>
            <p>
              <textarea class="form-control" rows="3" v-model="FormDatas.introduce" :placeholder="$t('b.ProductManage.HintFour')"></textarea>
            </p>
          </li>
        </ul>
      </div>

      <div class="FormStyleTwoLeft FloatBoxRow" v-else>
        <ul class="FormStyleTwo">
          <viewer @inited="inited" ref="viewer">
          <li class="FormStyleTwoImgBox FormStyleTwoRow">
            <div class='FormStyleTwoImg backImg' v-if="FormDatas.img" :style="{backgroundImage: 'url(' + FormDatas.img + ')'}">
              <img v-if="FormDatas.img" class="tableImgShow" :src="FormDatas.img" @click="PreviewImgs">
              <span class="icon iconfont iconicon-test33 RemoveImgIcon" @click.stop="RemoveImg"></span>
            </div>
            <div class='FormStyleTwoImg backImg' v-else></div>
            <div class="FormStyleTwoImgMore">
              <p class="hint" style="width:230px">{{$t('c.Common.ImageSize')}}</p>
              <p class="btnStyleTwo btnRadius blueBackColor" style="display:table;" @click="HandleModel(1,true)">{{$t('b.Material.UploadImages')}}</p>
            </div>
          </li>
          </viewer>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>{{$t('c.Common.ProductName')}}</p>
            <p><input :placeholder="$t('b.ProductManage.HintOne')" v-model="FormDatas.name" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">1月价格</p>
            <p><input v-model="FormDatas.attribute.January" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">2月价格</p>
            <p><input v-model="FormDatas.attribute.February" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">3月价格</p>
            <p><input v-model="FormDatas.attribute.March" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">4月价格</p>
            <p><input v-model="FormDatas.attribute.April" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">5月价格</p>
            <p><input v-model="FormDatas.attribute.May" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">6月价格</p>
            <p><input v-model="FormDatas.attribute.June" /></p>
          </li>
        </ul>
      </div>
      <div class="FormStyleTwoRight FloatBoxRow" v-if="uid == 1001">
        <ul class="FormStyleTwo">
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">7月价格</p>
            <p><input v-model="FormDatas.attribute.July" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">8月价格</p>
            <p><input v-model="FormDatas.attribute.August" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">9月价格</p>
            <p><input v-model="FormDatas.attribute.September" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">10月价格</p>
            <p><input v-model="FormDatas.attribute.October" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">11月价格</p>
            <p><input v-model="FormDatas.attribute.November" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">12月价格</p>
            <p><input v-model="FormDatas.attribute.December" /></p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="btnArray formFootBtnArr">
      <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm(1)"><span class="icon iconfont iconicon-test17"></span>{{$t('c.Common.Save')}}</a>
      <a class="btnStyleTwo btnRadius cyanBackColor" href="javascript:history.back();"><span class="icon iconfont iconicon-test18"></span>{{$t('c.Common.Back')}}</a>
    </div>

    <!-- 图片空间 -->
    <K-ImagePicker ref="imgPicker" :show-entry="false" @change="selectImg"></K-ImagePicker>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

	</div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Column from '@/components/common/Column.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import Confirm from '@/components/common/Confirm.vue'
import Swiper from 'swiper'
import ImagePicker from '@/components/common/ImagePicker.vue'
export default {
  name: 'HandleProduct',
  components: {
    'K-Paging': Paging,
    'K-Column': Column,
    'K-Transition': Transition,
    'K-Confirm': Confirm,
    'K-Loading': Loading,
    'K-Toast': Toast,
    'K-ImagePicker': ImagePicker
  },
  data () {
    return {
      $self:null,
      page:1,
      uid:null,
      id:null,  //产品ID
      tradeType:null,
      totalPages:0,
      uploadType:null,
      uploadImgIndex:null,
      subHint:'数据加载中...',
      isLoding:true,
      btype:null,
      column:[
        {name:'ProductManage',url:'ProductManage'}
      ],
      SelectArr:[{
        ix:0,
        active:false,
        datas:["no","yes"]
      },{
        ix:0,
        active:false,
        datas:[]
      },{
        ix:0,
        active:false,
        datas:["登记类别代码为PD","登记类别代码为WP","临时登记"]
      }],
      navix:0,
      leftIconTop:25,
      Classify:null,
      codeuse_code:null,
      industrycategory_id:null,
      industrycategory_code:null,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      Confirm:{
        state:false,
        txt:null,
        style:1
      },
      FormDatas:{
        img:null,
        name:null,
        period:null,
        unit:null,
        introduce:null,
        attribute:{
          January:null,
          February:null,
          March:null,
          April:null,
          May:null,
          June:null,
          July:null,
          August:null,
          September:null,
          October:null,
          November:null,
          December:null,
        },
        reg_code:null,
        reg_code_str:null,
        reg_code_owner:null,
        product_code:null,
        alias_name:null
      },
      code1:0,
      code2:0,
      code3:0,
    }
  },
  created () {
    self = this;
    self.$self = this;
    self.OID = localStorage.getItem("wwmxt_OID");
    self.tradeType = localStorage.getItem("wwmxt_TradeType");  //行业类型
    self.btype = localStorage.getItem("wwmxt_BType");  //商户类型
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
    if(this.$route.query.id){
      self.id = self.$route.query.id;
      self.column[1] = {name:'EditProduct',url:'ProductEdit?id='+self.$route.query.id};
      self.GetData();
    }else{
      self.column[1] = {name:'AddProduct',url:'ProductEdit'};
    }
    self.uid = localStorage.getItem("wwmxt_Rootid");
  },
  mounted () {
  },
  updated () {
    var category = new Swiper('#category', {
      slidesPerView : 3.5,
      slidesPerGroup : 1,
      spaceBetween : 10,
      slidesOffsetBefore : 30,
      observer:true,//修改swiper自己或子元素时，自动初始化swiper
      observeParents:true,//修改swiper的父元素时，自动初始化swiper
    })
  },
  methods: {
    GetData () {
      self.loading = true;
      axios.get(self.GetServerUrl(1)+"production/"+self.id)
      .then(function (response){
        let datas = response.data.meta;
        self.loading = false;
        if(datas.attribute){
          datas.attribute = JSON.parse(datas.attribute);
        }
        self.FormDatas = datas;

      }).catch(function (error){
        console.log(error)
        self.loading = false;
        self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
      })
    },
    ClickOIDNav (ix,id) {
      self.navix = ix;
      for(let item in self.OIDDatas){
        self.OIDDatas[item].icon = "icon_0"+(parseInt(item)+1)+".jpg"
      }
      self.OIDDatas[ix].icon = "icon_0"+(parseInt(ix)+1)+"_.jpg"
      if(ix == 0){
        self.leftIconTop = 25;
      }else if(ix == 1){
        self.leftIconTop = 135;
      }else if(ix == 2){
        self.leftIconTop = 250;
      }
    },
    SubmitForm (te) {
      if(te == 1){
        let datas = self.FormDatas;
        let te = "post";

        if(!self.FormDatas.name){
          self.ToastFun(1,"产品名称不能为空！");
          return;
        }

        //编辑
        if(self.id){
          te = "patch";
          datas.production_id = self.id;
        }
        datas.is_idcode = 0;

        self.loading = true;
        axios({
          method:te,
          url:self.GetServerUrl(1)+"production",
          data:datas
        }).then(function (response) {
          self.loading = false;
          self.Confirm.style = 1;
          self.Confirm.state = true;
          self.Confirm.txt = response.data.message+"，是否确定返回列表？"
        }).catch(function (error) {
          self.loading = false;
          self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
        })
      }else{
        self.ModelShow = false;
      }
    },
    HandleModel (te,status,ix) {  //通过外部按钮触发图片空间弹窗
      self.uploadType = te;
      self.uploadImgIndex = ix;
      if (status && self.$refs.imgPicker) {
        self.$refs.imgPicker.openPicker();
      }
    },
    selectImg (img) {
      if(self.uploadType == 1){
        self.FormDatas.img = img;
      }else{
        self.FormDatas.attribute[self.uploadImgIndex].value = img;
      }
    },
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    addAttributeRow () {
      if(!self.FormDatas.attribute){
        self.FormDatas.attribute = [];
      }
      self.FormDatas.attribute.unshift({key:"",value:""});
    },
    RemoveRow (ix) {
      self.FormDatas.attribute.splice(ix,1);
    },
    ConfirmBackFun (data) {
      self.Confirm.state = data.state;
      if(data.state){
        self.Confirm.state = false;
        javascript:history.back();
      }
    },
    RemoveImg () {
      self.FormDatas.img = null;
    },
    inited (viewer) {
      self.$viewer = viewer
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    },
    CodeFun (te,ix) {
      if(te == 1){
        eval("self.code" + ix + "= null");
      }else{
        if(!eval("self.code" + ix)){
          eval("self.code" + ix + "= 0");
        }
      }
    }
  }
}
</script>

<style scoped>
  .SelectStyle{
    width:300px;
  }
  .OIDProductBox{
    padding:20px;
    border-top: 1px solid #F3F3F3;
    border-bottom: 1px solid #F3F3F3;
  }
  .OIDProductID{
    padding-right:20px;
  }
  .OIDProductMain{
    overflow: hidden;
    margin-top:20px;
  }
  .OIDProductLeft{
    float: left;
    position: relative;
    padding-right: 40px;
    border-right: 2px solid #278BF5;
  }
  .OIDProductLeftRow{
    margin-top:20px;
    text-align: center;
    width:70px;
    cursor: pointer;
  }
  .OIDProductLeftRow:first-child{
    margin-top:0;
  }
  .OIDProductLeftIcon{
    width:65px;
  }
  .OIDProductLeftRowArrows{
    position: absolute;
    right:0;top:0;
    width: 8px;
  }
  .OIDProductRight{
    width: calc(100% - 120px);
  }
  .idboxRightMain{
  	width:220px !important;
  	height:316px !important;
  	border:1px solid #e3e3e3;
  }
  .idboxRight i{
  	color:#f30;
  }
  .ibrmBox{
  	padding:10px;
    height:257px;
    overflow-y: scroll;
  }
  .idboxRightMain span{
  	font-weight: bold;
  	padding:10px;
  	display: block;
  	font-size:0.95em;
  	background-color: #EEEEEE;
  	border-bottom:1px solid #e3e3e3;
  }
  .idboxRightMain p{
  	border-bottom:1px solid #eee;
  	padding:8px 10px;
  	font-size:0.85em;
  	color:#666;
  	cursor: pointer;
  }
  .idboxRightMain p:hover{
  	background-color: #EEEEEE !important;
  }
  .OIDProductLeftTitle{
    margin-top:5px;
    color:#585A64;
  }
  .activeNav{
    background-color: #EEE;
  }
  .FormInputArrRow:first-child{
    margin-left:0;
  }
  .FormInputArrRow{
    width:76px;
    margin-left:10px;
  }
</style>
